import React from "react";

import { useAuth } from "../../../../shared/hooks/useAuth";

import { LayersSideBar } from "../layers/layers-side-bar";
import { SearchSideBarCemetery } from "../search-cemetery/SearchSideBarCemetery";
import { SearchSideBar } from "../search/SeachSideBar";
import { SearchAnySideBar } from "../serach-any-layer/SeachAnySideBar";

export const SideBars: React.FC = () => {
    const { signed } = useAuth();

    if (!signed) return null;

    return (
        <>
            <LayersSideBar />
            <SearchSideBar />
            <SearchSideBarCemetery />
            <SearchAnySideBar />
        </>
    );
};
